import {
    listInputs,
    listOutputs
} from '../../audio/MidiController';
import { GlobalDataContext } from '../../GlobalDataContext';
import { normalizeClassName } from '../../render/renderUtils';
import './MidiDevicePanel.css';
import React, { useReducer } from 'react';
import { RydGrantMidiPermissionsButton } from './MidiDeviceSelectionDialog';
import { useMidiAccessStore } from '../../stores/MidiAccessStore';

function MidiDevicePanel() {

    const midiAccessStore = useMidiAccessStore();
    const [_, forceUpdate] = useReducer(x => x + 1, 0);
    const hasMidiAccess = midiAccessStore.midiAccess != null;

    return (
        <div className={normalizeClassName(['midi-device-panel', 'interaction-panel'])}>

            <div>
                {!hasMidiAccess && <RydGrantMidiPermissionsButton setMIDIAccess={midiAccessStore.setMidiAccess} />}
                {hasMidiAccess && <button onClick={forceUpdate}>Refresh devices</button>}
            </div>
            {hasMidiAccess &&
                <div>
                    Input:
                    <ul className='midi-device-panel--list'>
                        {listInputs(midiAccessStore.midiAccess).map((io) => <li key={io.id}>{io.name}</li>)}
                    </ul>
                    Output:
                    <ul className='midi-device-panel--list'>
                        {listOutputs(midiAccessStore.midiAccess).map((io) => <li key={io.id}>{io.name}</li>)}
                    </ul>
                </div>
            }
        </div>
    );
}

export { MidiDevicePanel };